export const isSpanishTransactionCountry = (
  countryCode: string | null | undefined,
  tenantCountryCode: string | null | undefined,
): boolean => (countryCode ?? tenantCountryCode) === 'ES';
